import React from "react";

import Carousal from "./Carousal";
import LoadingOverlay from "./LoadingOverlay";
import RegionScreen from "../containers/RegionScreen";
import CityScreen from "../containers/CityScreenContainer";
import TimeScreen from "../containers/TimeScreen";
import DurationScreen from "../containers/DurationScreen";
import ModelListOnlineScreen from "../containers/ModelListOnlineScreen";
import ModelListFavoriteScreen from "../containers/ModelListFavoriteScreen";
import VideosScreen from "../containers/VideosScreen";
import FiltersScreen from "../containers/FiltersScreen";
import ThankyouScreen from "../containers/ThankyouScreen";
import ModelScreen from "../containers/ModelScreen";
import BookScreen from "../containers/BookScreen";
import VerifyPhoneScreen from "../containers/VerifyPhoneScreen";
import VerifyEmailScreen from "../containers/VerifyEmailScreen";
import PhoneHelpScreen from "../containers/PhoneHelpScreen";
import CountriesScreen from "../containers/CountriesScreen";
import VerifyPhoneOtpScreen from "../containers/VerifyPhoneOtpScreen";
import VerifyEmailOtpScreen from "../containers/VerifyEmailOtpScreen";
import GenderScreen from "../containers/GenderScreen";
import ErrorScreen from "../containers/ErrorScreen";
import LoginScreen from "../containers/LoginScreen";
import OutcallScreen from "../containers/OutcallScreen";
import VerifyScreen from "../containers/VerifyScreen";
import ModelAlertScreen from "../containers/ModelAlertScreen";
import LocationScreen from "../containers/LocationScreen";
import Notifications from "./Notifications";
import VerifyPassword from "../containers/VerifyPassword";

import ReactModal from "react-modal";

const reactModalStyles = {
  overlay: {
    zIndex: 10,
    backgroundColor: "rgba(255, 255, 255, 0.85)",
  },
};

export default function Root({
  goTo,
  isLoading,
  loadingTitle,
  loadingMessage,
  error,
  success,
  isPremium,
  modelsVisible,
  modal,
  model,
  goBack,
  reportImage,
  imagesReported,
  unread,
  clearUserMessages,
}) {
  let modelsScreen;

  if (modal.screen === "models") {
    if (modelsVisible === "online") {
      modelsScreen = <ModelListOnlineScreen goTo={goTo} />;
    }

    if (modelsVisible === "favorite") {
      modelsScreen = <ModelListFavoriteScreen goTo={goTo} />;
    }

    if (modelsVisible === "videos") {
      modelsScreen = <VideosScreen goTo={goTo} />;
    }
  }

  return (
    <div className="legacy">
      <ReactModal
        isOpen={modal.isOpen}
        contentLabel="Modal"
        className="ReactModal__Content--full"
        portalClassName="ReactModalPortal legacy"
        style={reactModalStyles}
        ariaHideApp={false}
      >
        {modal.screen === "login" && (
          <LoginScreen goTo={goTo} isLoading={isLoading} errorMessage={error} />
        )}
        {modal.screen === "region" && <RegionScreen goTo={goTo} />}
        {modal.screen === "city" && <CityScreen goTo={goTo} />}
        {modal.screen === "gender" && <GenderScreen goTo={goTo} />}
        {modal.screen === "outcall" && <OutcallScreen goTo={goTo} />}
        {modal.screen === "location" && <LocationScreen goTo={goTo} />}
        {modal.screen === "time" && <TimeScreen goTo={goTo} />}
        {modal.screen === "duration" && (
          <DurationScreen goTo={goTo} isLoading={isLoading} />
        )}
        {modelsScreen}
        <FiltersScreen goTo={goTo} />
        <ErrorScreen goTo={goTo} />

        {model && (
          <div>
            {modal.screen === "model" && (
              <ModelScreen
                goTo={goTo}
                model={model}
                reviewsLoaded={typeof model.reviews !== "undefined"}
              />
            )}
            {modal.screen === "book" && (
              <BookScreen goTo={goTo} model={model} isLoading={isLoading} />
            )}
            {modal.screen === "model-alert" && (
              <ModelAlertScreen
                model={model}
                errorMessage={error}
                successMessage={success}
              />
            )}
            {modal.screen === "thankyou" && (
              <ThankyouScreen goTo={goTo} model={model} />
            )}

            {modal.screen === "carousal" && (
              <Carousal
                model={model}
                isPremium={isPremium}
                isOpen
                initialSlide={modal.carousalIdx}
                onClose={goBack}
                onReport={reportImage}
                imagesReported={imagesReported}
              />
            )}
          </div>
        )}
        {modal.screen === "verify" && (
          <VerifyScreen goTo={goTo} errorMessage={error} />
        )}
        {modal.screen === "verify-password" && (
          <VerifyPassword errorMessage={error} />
        )}
        {modal.screen === "verify-phone" && (
          <VerifyPhoneScreen goTo={goTo} errorMessage={error} />
        )}
        {modal.screen === "phone-help" && <PhoneHelpScreen />}
        {modal.screen === "countries" && (
          <CountriesScreen goBack={goBack} goTo={goTo} errorMessage={error} />
        )}
        {modal.screen === "verify-phone-otp" && (
          <VerifyPhoneOtpScreen goTo={goTo} errorMessage={error} />
        )}
        {modal.screen === "verify-email" && (
          <VerifyEmailScreen goTo={goTo} errorMessage={error} />
        )}
        {modal.screen === "verify-email-otp" && (
          <VerifyEmailOtpScreen goTo={goTo} errorMessage={error} />
        )}

        <Notifications {...{ unread, onPress: clearUserMessages }} />
      </ReactModal>
      {isLoading && (
        <LoadingOverlay title={loadingTitle} message={loadingMessage} />
      )}
    </div>
  );
}
